/* eslint-disable @typescript-eslint/no-explicit-any */
import Web3 from "web3";

// Extend the Window interface to include Ethereum
declare global {
  interface Window {
    ethereum: {
      request: (args: { method: string }) => Promise<string>;
      send: (method: string) => Promise<void>;
      enable: () => Promise<string[]>;
      selectedAddress: string | null;
      networkVersion: string;
    };
    web3?: {
      currentProvider: any;
    };
  }
}

let web3: Web3 | null = null;

const getWeb3 = async (): Promise<Web3 | null> => {
  if (typeof window !== "undefined" && window.ethereum) {
    web3 = new Web3(window.ethereum);
    try {
      // Request account access if needed
      await window.ethereum.request({ method: "eth_requestAccounts" });
    } catch (error) {}
  } else if (typeof window !== "undefined" && window.web3) {
    web3 = new Web3(window.web3.currentProvider);
  } else {
    web3 = new Web3(
      new Web3.providers.HttpProvider("https://bsc-dataseed.binance.org/"),
    );
  }

  return web3;
};

// Initialize web3 immediately
if (!web3) {
  getWeb3();
}

export { web3, getWeb3 };
